import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=512c4816&"
import script from "./Docs.vue?vue&type=script&lang=ts&"
export * from "./Docs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports